import { Col, Container, Row } from 'react-bootstrap'
import styled from 'styled-components'
export const ProjectsSection = styled.div`
    padding-top: .5rem;
    >h4{
        margin-bottom:.5rem;
        font-family:${({ theme }) => theme.font.first};
        font-weight:700;
        color: ${({ theme }) => theme.color.fourth};
    }
    .swiper {
        border-radius:10px;
        padding: .5rem ;
    }
`
export const ProjectsCard = styled.div`
    padding: 1rem;
    background-color: ${({ theme }) => theme.color.third};
    border-radius:5px;
    
    .swiper-slide{
        background-image:linear-gradient(to top,${({ theme }) => theme.color.second} 10% ,rgba(0,0,0,0));
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 0 10px ${({ theme }) => theme.color.sixth};
    }
    .swiper-slide-active{
        background-image:linear-gradient(to top,rgba(0,0,0,0) ,rgba(0,0,0,0));
        border-radius:10px;
    }
    .swiper-slide-active:hover{
        background-image:linear-gradient(to top,${({ theme }) => theme.color.second} 10% ,rgba(0,0,0,0));
        border-radius:10px;

    }
`
export const SwiperCard = styled.div`
    height:15rem;
    width: 100%;
    border-radius:10px;
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.color.first};
    background-image:url(${(props) => props.bgImage});
    background-repeat: no-repeat, repeat;
    background-size: cover;
    position: relative;
    &:hover{
        background-image: linear-gradient(to top,${({ theme }) => theme.color.second} 10%,rgba(0,0,0,0) 50%),url(${(props) => props.bgImage})  ;
        >div{
            display: flex;
        }
    }
`
export const ProjectLinks = styled.div`
    height: 5rem;
    width: 100%;
    display: none;
    align-items: center;
    justify-content:space-around;
    position:absolute;
    bottom: 0;
    padding:1rem;
    cursor: none;
    /* opacity:0;
    transition: opacity 2s;
    &:hover{
        opacity:1;
    } */
    a{
        background-color:${({ theme }) => theme.color.second};
        padding: .5rem;
        height: 2.5rem;
        width: 2.5rem;
        border-radius:10px;
        display: flex;
        align-items: center;
        justify-content:center;
        box-shadow: 0 0 10px 5px ${({ theme }) => theme.color.sixth};
        &:active{
            height: 2rem;
            width: 2rem;
        }
        >svg{
            color:${({ theme }) => theme.color.sixth};
            height: 100%;
            width: 100%;
        }
    }
`